import { IParamsGetNotificationHistory } from 'app/api/company/notification/type'

export const NotificationKeys = {
  allHistories: ['Histories'] as const,
  listHistories: () => [...NotificationKeys.allHistories, 'listHistories'] as const,
  getListHistory: (filters?: IParamsGetNotificationHistory) =>
    [...NotificationKeys.listHistories(), { filters }] as const,
}
